export class HotelImage {
  aspectHeight: string;
  aspectWidth: string;
  url: string;
  constructor(url: string, aspectHeight?: string, aspectWidth?: string) {
    this.url = url;
    this.aspectHeight = aspectHeight;
    this.aspectWidth = aspectWidth;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/hotel/hotel-image.model.ts